import { instance } from "../api-instance";

export const ContactApi = {
  getUniquenessState: (contactId: string): Promise<unknown> =>
    instance
      .get(`contact/${contactId}/uniquenessState`)
      .then((res) => res.data),

  addYandexClientData: ({
    clientId,
    contactId,
    contactSource,
  }: {
    clientId: string;
    contactId: string;
    contactSource: string;
  }): Promise<unknown> =>
    instance
      .post("contact/addYandexClientData", {
        clientId,
        contactId,
        contactSource,
      })
      .then((res) => res.data),
};
